import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Field, formValueSelector, change, getFormValues } from 'redux-form';
import CheckboxField from './../checkbox';
import SelectField from './../../genFields/select';
import RadioField from './../../genFields/radio';
import DateField from './../date';
import TextField from './../text';
import Question from '../../../models/question';
import { getByPath } from '../../../utilities/string';
import messages from '../../../text/messages';
import HelpButton from '../../richButtons/helpButton';

class FieldGenerator extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};

        this.buildQuestion = this.buildQuestion.bind(this);
        this.interpolateLabel = this.interpolateLabel.bind(this);

        this.renderRadio = this.renderRadio.bind(this);
    }

    renderRadio(question, o, current) {
        let prop = question.name;
        if (this.props.skipOnChange) {
            prop = `${this.props.formSectionName}.${prop}`;
        }
        return getByPath(current, prop, '').toString() === o.value.toString() ? 'radio_button_checked' : 'radio_button_unchecked';
    }

    interpolateLabel(label) {
        const { client_name } = this.props;
        return label.replace(/{clientName}/g, client_name);
    }

    buildQuestion(question) {
        const { values, formName, changeField, fieldData, disabled, validate, skipOnChange } = this.props;
        const qAnswer = (question.answer && question.answer.answer) || '';

        let { label, helpText } = question;
        label = this.interpolateLabel(label, {});

        let field = null;
        switch (question.type) {
            case 'y/n':
                field = (
                    <Field
                        name={question.name}
                        placeholder={label}
                        component={RadioField}
                        validate={validate}
                        helpText={helpText}
                        options={question.options.map(o => ({
                            ...o,
                            label: (
                                <React.Fragment>
                                    <i className="material-icons">{this.renderRadio(question, o, values)}</i>
                                    <span>{o.label}</span>
                                </React.Fragment>
                            )
                        }))}
                        selectedValue={fieldData ? fieldData.value : qAnswer}
                        {...(skipOnChange
                            ? {}
                            : {
                                  input: {
                                      onChange: e => changeField(formName, question.id, { value: e.target.value }),
                                      name: question.name,
                                      disabled: disabled
                                  }
                              })}
                    />
                );
                break;

            case 'multi':
                field = (
                    <div className="checkbox-generated-field">
                        <div className="checkbox-field-outer-label">{label}</div>
                        {question.options.map((option, i) => {
                            let name = `${question.name}.${option.value}`;
                            return (
                                <Field key={i} name={name} checked={getByPath(values, name) || false} placeholder={option.label} component={CheckboxField} />
                            );
                        })}
                    </div>
                );
                break;

            case 'select':
                field = (
                    <React.Fragment>
                        <div className="row">
                            <div className="col-xs-12 col-md-9 col-sm-8">
                                <div className="radio-label-wrapper">
                                    <div className="label-container">{label}</div>
                                    {helpText && <HelpButton text={helpText} />}
                                </div>
                            </div>
                            <div className="col-xs-12 col-md-3 col-sm-4">
                                <Field
                                    name={question.name}
                                    placeholder={question.placeholder || messages.choose}
                                    component={SelectField}
                                    options={question.options}
                                    validate={validate}
                                />
                            </div>
                        </div>
                    </React.Fragment>
                );
                break;

            case 'date':
                field = (
                    <React.Fragment>
                        <div className="form-group">{label}</div>
                        <Field
                            name={question.name}
                            selectedDate={values && values[question] ? values[question] : null}
                            placeholder={messages.dateFormat}
                            component={DateField}
                            validate={validate}
                        />
                    </React.Fragment>
                );
                break;

            case 'text':
                field = (
                    <React.Fragment>
                        <div className="form-group">{label}</div>
                        <Field name={question.name} placeholder={question.placeholder || messages.emptyMessage} component={TextField} validate={validate} />
                    </React.Fragment>
                );
                break;

            default:
                break;
        }

        return field;
    }

    renderFollowup(f, i) {
        const { answer_type } = f;
        const className = answer_type === 'text' ? 'col-sm-12' : 'col-sm-6 col-xs-12';
        return (
            <div className={className} key={i}>
                {this.buildQuestion(new Question(f))}
            </div>
        );
    }

    render() {
        const { definition, allDefinitions, formName, showFollowup } = this.props;
        if (!definition || !allDefinitions || !formName) {
            return null;
        }

        let question = new Question(definition);
        if (question.isFollowup) {
            return null;
        }

        let followups = showFollowup && question.hasFollowups() ? allDefinitions.filter(a => question.followups.filter(f => a.id === f).length > 0) : undefined;
        return (
            <div className="form-generator">
                {this.buildQuestion(question)}
                {followups && <div className="row followup-questions">{followups.map((f, i) => this.renderFollowup(f, i))}</div>}
            </div>
        );
    }
}

FieldGenerator.defaultProps = {
    definition: undefined,
    formName: undefined,
    allQuestions: undefined,
    disabled: false,
    client_name: 'your company',
    skipOnChange: false,
    validate: () => undefined
};

FieldGenerator.propTypes = {
    definition: PropTypes.object.isRequired,
    formName: PropTypes.string.isRequired,
    formSectionName: PropTypes.string,
    disabled: PropTypes.bool,
    validate: PropTypes.func,
    allQuestions: PropTypes.array,
    skipOnChange: PropTypes.bool
};

const mapStateToProps = (state, props) => {
    const selector = formValueSelector(props.formName);
    let selectedData = selector(state, new Question(props.definition).id);
    return {
        allDefinitions: props.allQuestions || state.formInstances.questions,
        fieldData: selectedData,
        showFollowup: selectedData && (typeof selectedData.value === 'string' ? selectedData.value !== 'false' : true),
        values: getFormValues(props.formName)(state)
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            changeField: change
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(FieldGenerator);



// WEBPACK FOOTER //
// ./src/components/fields/generator/index.jsx